<template>
  <div
    class="navbar-container d-flex content align-items-center"
    style="margin-bottom: -0.5rem;margin-top: -0.5rem;"
  >

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <!-- <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div> -->

    <!-- Empresa selecionada pelo usuário externo -->
    <empresa-externa v-if="isExternalAuthenticated()" />

    <b-navbar-nav v-if="!isExternalAuthenticated() && !isAccessNotAuthenticated()">
      <b-nav-item :to="'/tela-favoritos'">
        <div style="display: flex;align-items: center;">
          <feather-icon
            icon="StarIcon"
            style="margin-right: 0.5rem;color: var(--primary);"
          />
          {{ currentRouteName === 'tela-favoritos' ? 'Favoritos' : 'Acessar favoritos' }}
        </div>
      </b-nav-item>
    </b-navbar-nav>

    <!-- Menu de seleção de modulos -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <div v-if="!isExternalAuthenticated() && !isAccessNotAuthenticated()">

        <span style="float: left;margin-top: 10px;">Seleção de módulo :</span>
        <div class="tag-modulo">
          <b-nav-item-dropdown

            toggle-class="d-flex align-items-center dropdown-user-link"
            class="dropdown-user"
          >
            <template #button-content>
              <div class="d-sm-flex d-none">
                <b-img
                  :src="imgModulo"
                  height="40px"
                  width="40px"
                  rounded="circle"
                />
                <div
                  v-if="imgModulo == imgComercial"
                  class="modulo-letra"
                >
                  Comercial
                </div>
                <div
                  v-if="imgModulo == imgCobranca"
                  class="modulo-letra"
                >
                  Cobrança
                </div>
                <div class="chevronicon">
                  <feather-icon
                    size="20"
                    icon="ChevronDownIcon"
                    class="mr-50"
                  />
                </div>
              </div>
            </template>
            <b-dropdown-item
              v-if="modulos.includes('Cobrança')"
              link-class="d-flex align-items-center"
              class="cobranca-color"
              @click="alterarModulo('Cobrança')"
            >
              <div style="margin-left: 0px;">
                <b-img
                  :src="imgCobranca"
                  height="25px"
                  width="25px"
                />
                <span>{{ 'Cobrança' }}</span>
              </div>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="modulos.includes('Comercial')"
              link-class="d-flex align-items-center"
              class="comercial-color"
              @click="alterarModulo('Comercial')"
            >
              <div style="margin-left: 0px;">
                <b-img
                  :src="imgComercial"
                  height="25px"
                  width="25px"
                />
                <span>{{ 'Comercial' }}</span>
              </div>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </div>
      </div>

      <b-nav-item-dropdown
        v-if="!isAccessNotAuthenticated()"
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ getNome() }} <!-- Demo auditar -->
            </p>
            <span class="user-status">{{ getGrupo() }}</span> <!-- Admin -->
          </div>
        </template>

        <!-- Validar se é usuário interno - v-if... -->
        <b-dropdown-item
          v-if="!isExternalAuthenticated()"
          link-class="d-flex align-items-center"
          @click="goProfile"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Meu perfil</span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item
        v-else
        right
        class="dropdown-user"
      >
        <template>
          <p
            class="user-name font-weight-bolder mb-0"
            style="text-align: right;"
          >
            {{ getNome() }}
          </p>
          <span class="user-status">
            {{ getEmail() }}
          </span>
        </template>
      </b-nav-item>
    </b-navbar-nav>
    <b-button
      v-if="!isExternalAuthenticated() && !isAccessNotAuthenticated()"
      variant="link"
      class="d-flex align-items-center p-0 notification-button"
      @click="openNotificationsDrawer"
    >
      <div style="position: relative;">
        <feather-icon
          icon="BellIcon"
          size="20"
          class="mr-50"
        />
        <span
          v-if="unreadNotificationCount > 0"
          style="
            position: absolute;
            top: -5px;
            right: -5px;
            background-color: red;
            color: white;
            border-radius: 50%;
            padding: 2px 6px;
            font-size: 0.8rem;
            font-weight: bold;
          "
        >
          {{ unreadNotificationCount > 9 ? '9+' : unreadNotificationCount }}
        </span>
      </div>
    </b-button>
    <NotificationsDrawer
      v-if="!isExternalAuthenticated() && !isAccessNotAuthenticated()"
      :is-drawer-visible.sync="isDrawerVisible"
      :has-notifications="hasNotifications"
      :notification-count="notificationCount"
      :notifications="notifications"
      @open-notification-modal="openNotificationModal"
      @notification-drawer-closed="checkUnreadNotifications"
    />

    <!-- Adicionando listener global para o evento -->
    <div
      v-if="!isExternalAuthenticated() && !isAccessNotAuthenticated()"
      @open-notification-modal="openNotificationModal">
      <!-- Notification Modal -->
      <NotificationModal
        v-if="selectedNotification"
        :notification="selectedNotification"
        :show="isNotificationModalVisible"
        @close-notification-modal="closeNotificationModal"
      />
    </div>
  </div>
</template>

<style lang="scss">
.chevronicon {
  align-self: center;
  color: #6b6b6b;
  margin-right: -7px;
  margin-left: 5px;
}
.modulo-letra {
  color: var(--primary) !important;
  font-weight: bold;
  padding: 4px !important;
  align-self: center;
  margin-left: -2px;
}
.tag-modulo {
  margin-left: 5px;
  border: 0.80px solid var(--primary) !important;
  background-color: transparent;
  color: var(--primary) !important;
  padding-bottom: 4px !important;
  display: inline-flex;
  font-weight: bold;
  border-radius: 6px;
}
.dropdown-menu li.comercial-color a:hover {
  background-color: rgba(0, 204, 102, 0.1) !important;
  color: #00cc66 !important;
}

.dropdown-menu li.comercial-color a:focus {
  background-color: rgba(0, 204, 102, 0.1) !important;
  color: #00cc66 !important;

}

.dropdown-menu li.comercial-color a:active {
  background-color: #00cc66 !important;
  color: white !important;
}

.dropdown-menu li.cobranca-color a:hover {
  background-color: rgba(193, 175, 29, 0.1) !important;
  color: #c1af1d !important;
}

.dropdown-menu li.cobranca-color a:focus {
  background-color: rgba(193, 175, 29, 0.1) !important;
  color: #c1af1d !important;
}

.dropdown-menu li.cobranca-color a:active {
  background-color: #c1af1d !important;
  color: white !important;
}
.color-icon-action {
  color: var(--primary);
  cursor: pointer;
}
</style>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BImg, // BAvatar,
} from 'bootstrap-vue'
// import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { mapActions } from 'vuex'
import {
  getUserInfo, isExternalAccess, getModulos, isAccessNotAuthenticated,
  isUserLoggedIn,
} from '@/auth/utils'
import EmpresaExterna from './EmpresaExterna.vue'
import NotificationsDrawer from './NotificationsDrawer.vue'
import NotificationModal from './NotificationModal.vue'
import api from '@/app-modulo/comuns/notificacao/shared/services/api'

const srcCobranca = require('@/assets/images/modulos/cobranca.png')
const srcComercial = require('@/assets/images/modulos/comercial.png')

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BImg,
    EmpresaExterna,
    NotificationsDrawer,
    NotificationModal,
    // BAvatar,

    // Navbar Components
    // DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      imgModulo: srcCobranca,
      imgCobranca: srcCobranca,
      imgComercial: srcComercial,
      modulos: [],
      isDrawerVisible: false,
      hover: null,
      hasNotifications: true,
      notificationCount: 0,
      notifications: [],
      selectedNotification: null,
      isNotificationModalVisible: true,
      unreadNotificationCount: 0, // Nova propriedade para armazenar notificações não lidas
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
  },
  created() {
    this.modulos = getModulos()
    if (localStorage.moduloSelecionado && this.modulos.includes(localStorage.moduloSelecionado)) {
      this.alterarModulo(localStorage.moduloSelecionado)
    } else if (this.modulos && this.modulos[0]) {
      this.alterarModulo(this.modulos[0])
    }
  },
  mounted() {
    this.fetchNotifications()
    setInterval(this.checkUnreadNotifications, 190000) // 190 segundos (3 minutos e 10 segundos)
  },
  methods: {
    ...mapActions('empresaExGlobal', ['setEmpresa']),
    logout() {
      this.setEmpresa(null)
      if (this.$router.history.current.path.indexOf('portal-clientes') > 0) {
        this.$router.push({ name: 'portalcliente-login' })
      } else {
        this.$router.push({ name: 'auth-login' })
      }
    },
    goProfile() {
      this.$router.push({ name: 'perfil' })
    },
    getNome() {
      return getUserInfo().nome
    },
    getGrupo() {
      return getUserInfo().grupo
    },
    getEmail() {
      return getUserInfo().email
    },
    isExternalAuthenticated() {
      return isExternalAccess() && !isAccessNotAuthenticated()
    },
    isAccessNotAuthenticated() {
      return isAccessNotAuthenticated()
    },
    alterarModulo(modulo) {
      if (localStorage.moduloSelecionado && modulo !== localStorage.moduloSelecionado) {
        this.$emit('update-menu')
      }

      if (modulo === 'Cobrança') {
        this.imgModulo = this.imgCobranca
        document.querySelector(':root').style.setProperty('--primary', '#c1af1d')
        document.querySelector(':root').style.setProperty('--primary-rgb', '193, 175, 29')
        const name = 'portaldocumentos-inerno'
        // eslint-disable-next-line no-underscore-dangle
        if (this.$route.name !== name && localStorage.moduloSelecionado && modulo !== localStorage.moduloSelecionado) {
          this.$router.push({ name: 'portaldocumentos-inerno' })
        }
        localStorage.setItem('moduloSelecionado', 'Cobrança')
      } else {
        this.imgModulo = this.imgComercial
        document.querySelector(':root').style.setProperty('--primary', '#00cc66')
        document.querySelector(':root').style.setProperty('--primary-rgb', '0, 204, 102')
        const name = 'painel-proposta'
        // eslint-disable-next-line no-underscore-dangle
        if (this.$route.name !== name && localStorage.moduloSelecionado && modulo !== localStorage.moduloSelecionado) {
          this.$router.push({ name: 'painel-proposta' })
        }
        localStorage.setItem('moduloSelecionado', 'Comercial')
      }
    },
    openNotificationsDrawer() {
      this.fetchNotifications() // Busca notificações ao abrir o drawer
      this.isDrawerVisible = false // Garante que o valor seja redefinido
      this.$nextTick(() => {
        this.isDrawerVisible = true // Reabre o drawer
      })
    },
    async fetchNotifications() {
      if (!isUserLoggedIn()) return
      if (isExternalAccess() || isAccessNotAuthenticated()) return

      const filtros = {}
      const response = await api.getNotificacoesUsuario(1, 10, filtros)
      this.notifications = response.data.notificacoes
      this.notificationCount = this.notifications.length
      this.unreadNotificationCount = this.notifications.filter(notification => !notification.visualizada).length // Armazena notificações não lidas
      this.hasNotifications = this.notifications.length > 0
    },
    async checkUnreadNotifications() {
      if (!isUserLoggedIn()) return
      if (isExternalAccess() || isAccessNotAuthenticated()) return

      const response = await api.getNotificacoesUsuarioNaoLidas() // Passa o filtro para a API
      this.unreadNotificationCount = response.data // Atualiza a contagem de notificações não lidas
    },
    openNotificationModal(notification) {
      this.selectedNotification = notification
      this.isNotificationModalVisible = true
    },
    closeNotificationModal() {
      this.selectedNotification = null
      this.isNotificationModalVisible = false
    },
  },
}
</script>
